// Order of items in below option lists cannot change
import { commitmentUnionTypes, levelUnionTypes, responsibilityUnionTypes, activityDurationUnitUnionTypes, certificateUnionTypes, competitionPlaceUnionTypes, meetupAttendeesUnionTypes, meetupTypesUnionTypes, prizeCategoryUnionTypes, jurisdictionUnionTypes } from './unionTypes';
export var commitmentOptionList = [{
  value: commitmentUnionTypes[0],
  text: 'Full Time'
}, {
  value: commitmentUnionTypes[1],
  text: 'Part Time'
}];
export var levelOptionList = [{
  value: levelUnionTypes[0],
  text: 'Graduate'
}, {
  value: levelUnionTypes[1],
  text: 'Junior'
}, {
  value: levelUnionTypes[2],
  text: 'Mid Level'
}, {
  value: levelUnionTypes[3],
  text: 'Senior'
}, {
  value: levelUnionTypes[4],
  text: 'Veteran'
}];
export var responsibilityOptionList = [{
  value: responsibilityUnionTypes[0],
  text: 'Team Member'
}, {
  value: responsibilityUnionTypes[1],
  text: 'Lead'
}, {
  value: responsibilityUnionTypes[2],
  text: 'Manager'
}, {
  value: responsibilityUnionTypes[3],
  text: 'Leader'
}];
export var activityDurationUnitOptionList = [{
  value: activityDurationUnitUnionTypes[0],
  text: 'Days'
}, {
  value: activityDurationUnitUnionTypes[1],
  text: 'Weeks'
}, {
  value: activityDurationUnitUnionTypes[2],
  text: 'Months'
}, {
  value: activityDurationUnitUnionTypes[3],
  text: 'Years'
}];
export var certificateTypeOptionList = [{
  value: certificateUnionTypes[0],
  text: 'General'
}, {
  value: certificateUnionTypes[1],
  text: 'Cert I'
}, {
  value: certificateUnionTypes[2],
  text: 'Cert II'
}, {
  value: certificateUnionTypes[3],
  text: 'Cert III'
}, {
  value: certificateUnionTypes[4],
  text: 'Cert IV'
}, {
  value: certificateUnionTypes[5],
  text: 'Postgraduate'
}, {
  value: certificateUnionTypes[6],
  text: 'Post Baccalaureate'
}, {
  value: certificateUnionTypes[7],
  text: 'Post Masters'
}, {
  value: certificateUnionTypes[8],
  text: 'Specialist'
}];
export var competitionPlaceOptionList = [{
  value: competitionPlaceUnionTypes[0],
  text: '1st Place'
}, {
  value: competitionPlaceUnionTypes[1],
  text: '2nd Place'
}, {
  value: competitionPlaceUnionTypes[2],
  text: '3rd Place'
}, {
  value: competitionPlaceUnionTypes[3],
  text: 'Participant'
}];
export var meetupAttendeesOptionList = [{
  value: meetupAttendeesUnionTypes[0],
  text: '1-10'
}, {
  value: meetupAttendeesUnionTypes[1],
  text: '11-25'
}, {
  value: meetupAttendeesUnionTypes[2],
  text: '26-50'
}, {
  value: meetupAttendeesUnionTypes[3],
  text: '50-100'
}, {
  value: meetupAttendeesUnionTypes[4],
  text: '100+'
}];
export var meetupTypesOptionList = [{
  value: meetupTypesUnionTypes[0],
  text: 'Private'
}, {
  value: meetupTypesUnionTypes[1],
  text: 'Open'
}, {
  value: meetupTypesUnionTypes[2],
  text: 'Ticketed'
}];
export var courseOptionList = [{
  value: 1,
  text: '1 year'
}, {
  value: 2,
  text: '2 years'
}, {
  value: 3,
  text: '3 years'
}, {
  value: 4,
  text: '4 years'
}, {
  value: 5,
  text: '5 years'
}, {
  value: 6,
  text: '6 years'
}, {
  value: 7,
  text: '7 years'
}, {
  value: 8,
  text: '8 years'
}, {
  value: 9,
  text: '9 years'
}, {
  value: 10,
  text: '10 years'
}, {
  value: 11,
  text: '11 years'
}, {
  value: 12,
  text: '12 years'
}];
export var prizeCategoryOptionList = [{
  value: prizeCategoryUnionTypes[0],
  text: 'Academic'
}, {
  value: prizeCategoryUnionTypes[1],
  text: 'Government'
}, {
  value: prizeCategoryUnionTypes[2],
  text: 'Humanitarian'
}, {
  value: prizeCategoryUnionTypes[3],
  text: 'Public Service'
}, {
  value: prizeCategoryUnionTypes[4],
  text: 'Military'
}, {
  value: prizeCategoryUnionTypes[5],
  text: 'Law Enforcement'
}, {
  value: prizeCategoryUnionTypes[6],
  text: 'Sports'
}];
export var jurisdictionOptionList = [{
  value: jurisdictionUnionTypes[0],
  text: 'Organisation'
}, {
  value: jurisdictionUnionTypes[1],
  text: 'Community'
}, {
  value: jurisdictionUnionTypes[2],
  text: 'State'
}, {
  value: jurisdictionUnionTypes[3],
  text: 'National'
}, {
  value: jurisdictionUnionTypes[4],
  text: 'World'
}];